const getTestId = (id) => (process.env.NODE_ENV === 'development' ? { testID: id } : {});

export default { getTestId };
